import { useSelfTimeCapsules } from "api/ApiHooks"
import { Link, useParams } from "react-router-dom"
import { TimeCapsuleListItem } from "./TimeCapsuleListItem"

export const OwnTimeCapsuleList = ({ onClick }: { onClick?: () => void }) => {
  const ownTimeCapsulesQuery = useSelfTimeCapsules()
  const { slug } = useParams()

  return (
    <>
      <div className="text-xs/6 font-semibold text-gray-400">My Capsules</div>
      <ul role="list" className="-mx-2 mt-2 space-y-2">
        {ownTimeCapsulesQuery.isLoading && (
          <p className="text-xs/7 font-semibold text-gray-400">Loading...</p>
        )}
        {ownTimeCapsulesQuery.data?.timeCapsules.map((capsule) => (
          <TimeCapsuleListItem
            id={capsule.id}
            slug={capsule.slug}
            name={capsule.name}
            opensAt={capsule.opensAt}
            isSelected={slug === capsule.slug}
            onClick={onClick}
          />
        ))}

        <li>
          <Link
            to={"/new/time-capsule"}
            onClick={onClick}
            className={
              " text-gray-700 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold hover:bg-gray-50 hover:text-primary-600"
            }
          >
            <span
              className={
                "text-gray-700 flex h-6 w-6 shrink-0 items-center justify-center font-medium"
              }
            >
              +
            </span>
            <span className="truncate">Create new capsule</span>
          </Link>
        </li>
      </ul>
    </>
  )
}
